<template>
  <div class="chat-container">
    <!-- 左侧用户列表 -->
    <div class="people-list">
      <div class="people-header">
        <span>消息列表</span>
        <span class="online-count">{{ Object.keys(onlineUsers).length }}</span>
      </div>
      <div class="people-content">
        <div v-for="user in onlineUsers" :key="user.customer_id" class="people-item" @click="setChatAccount(user)"
          :class="{ 'current-user': user.customer_id === current_account.customer_id }">
          <div class="user-avatar">
            <div :class="{ 'user-avatar-haveMessage': user.messages && user.messages.length > 0 }"></div>
            {{ user.nick_name ? user.nick_name.charAt(0).toUpperCase() : user.customer_id.charAt(0).toUpperCase() }}
          </div>
          <div class="user-info" :style="{ border: user.customer_id === current_account.customer_id ? 'none' : '' }">
            <div class="user-name-list"
              :class="{ 'user-name-list-select': user.customer_id === current_account.customer_id }">
              {{ user.nick_name ? user.nick_name : user.customer_id }}
            </div>
            <div class="user-status">在线</div>
          </div>
        </div>
        <div v-if="Object.keys(onlineUsers).length === 0" class="empty-users">
          <span>暂无其他用户在线</span>
        </div>
      </div>
    </div>

    <!-- 右侧聊天区域 -->
    <div class="chat-main">
      <div class="chat-header">
        <div class="title-section">
          <span class="chat-title"><!-- TODO:应该放用户名称 --></span>
          <span :class="['connection-badge', { disconnected: !isConnected }]">
            {{ isConnected ? '● 在线' : '○ 离线' }}
          </span>
        </div>
        <div class="user-info" style="border: none;">
          <span class="user-name">{{ current_account.nick_name || current_account.customer_id }}</span>
        </div>
      </div>

      <!-- 消息列表区域 -->
      <div class="message-area" ref="messageContainer">
        <div v-for="(msg, idx) in messages" :key="idx"
          :class="msg.senderId === agent_info.account_id ? 'message-line' : ''">
          <!-- 系统消息单独渲染 -->
          <div v-if="msg.type === 'system'" class="system-message">
            {{ msg.content }}
          </div>
          <!-- 普通聊天消息 -->
          <div v-else :class="['message', { own: msg.senderId === (agent_info.account_id) }]">
            <div class="message-bubble">
              <div class="message-info">
                <span class="message-sender">{{ getSenderName(msg.senderId) }}</span>
                <span class="message-time">{{ msg.time }}</span>
              </div>
              <div>{{ msg.content }}</div>
            </div>
          </div>
        </div>
        <div v-if="messages.length === 0" class="system-message" style="margin-top: 30px;">
          ✨ 开始聊天吧 ✨
        </div>
      </div>

      <div class="status-bar" v-if="!isConnected" @click="reconnectWebSocket">
        ⚠️ 连接已断开，尝试重连或点击「此处」重连
      </div>
      <div class="status-bar" v-if="!this.current_account.customer_id">
        ⚠️ 点击左侧用户之后开始通话
      </div>
      <div class="input-area">
        <input type="text" v-model="newMessage" @keyup.enter="sendMessage(newMessage)" class="message-input"
          :placeholder="isConnected ? '输入消息...' : '未连接到服务器'"
          :disabled="!isConnected || !this.current_account.customer_id" maxlength="500">
        <button class="send-btn" @click="sendMessage(newMessage)"
          :disabled="!isConnected || !newMessage.trim() || !this.current_account.customer_id">
          发送 ➤
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { checkJson } from '@/js/public.js';
import { getChatList } from "@/api/wss/wss";
import { accountQuery } from "@/api/login.js";
//eslint-disable-next-line
import WSMessageProtocol from "@/api/wss/analysisWssMessage";
export default {
  name: 'ChatRoom',
  data() {
    return {
      messages: [], // 消息列表 { type, content, senderId, senderName, time }
      newMessage: '',
      isConnected: false,
      agent_info: {
        nick_name: "王腾云",
        account_id: localStorage.getItem("account_id")
      },

      current_account: { //选中的用户信息
        customer_id: localStorage.getItem("customer_id"),
        nick_name: localStorage.getItem("nick_name")
      },
      socket: null,
      reconnectTimer: null,
      reconnectAttempts: 0,
      MAX_RECONNECT: 5,
      allowNameEdit: true,
      onlineUsers: {}, // 用户列表
      analysis: null //文本解析对象
    };
  },
  computed: {
    websocket() {
      return this.$store.state.webSocket.ws;
    }
  },
  mounted() {
    this.clearWebSocket();
    this.startWebSocket();// 建立 WebSocket 连接
    this.getChatList(); //获取消息列表
    this.getAccountQuery(); //获取客服信息
    this.analysis = new WSMessageProtocol();//实例化文本解析对象
  },
  watch: {
    /* messages(n, o) {
      console.log("nnnnnnnnnnnnnnnn", n);
    }, */
    /**
     * 监听连接状态
     * @param newType
     * @param oldType
     */
    "webSocket.OPEN"(newType, oldType) {
      console.log("连接状态变化", newType);
      if (newType === 0) {
        this.reconnectWebSocket();
      }
    },
    websocket: {
      handler(newVal) {
        //eslint-disable-next-line
        const that = this;
        if (newVal.OPEN === 1) {
          this.isConnected = true;
        } else {
          this.isConnected = false;
        }
        if (newVal) {
          newVal.onmessage = (event) => { //系统消息
            console.log("接收到消息", event.data);
            if (event && event.data && event.data.indexOf("{") > -1 && checkJson(event.data)) {
              let pevent = checkJson(event.data);
              console.log("pevent接收到的系统消息", pevent);
            } else { //对话消息
              if (event.data.length === 1 && event.data === "1") { //表示数据发送成功

              } else if (event.data.length > 26) { //表示接收到正常数据
                //接收到消息，解析数据
                let data = this.analysis.decode(event.data);
                console.log("解析后的消息", data);
                if (data && data.data) {
                  const info = {
                    ...data,
                    senderId: data.receiverId,
                    senderName: "", //this.current_account.nick_name
                    rawReceiverId: this.agent_info.account_id
                  }
                  console.log("info", info);
                  this.pullChatMessage(info);
                }
              }
              /* const first10 = comment.substring(0, 10);
              this.addChatMessage(first10, "用户", comment); */
            }
          };
        }
      },
      deep: true
    }
  },
  beforeDestroy() {
    this.cleanup();
    //window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  },
  methods: {
    ...mapActions('webSocket', ['startWebSocket', 'sendWebSocketMessage', 'reconnectWebSocket', 'clearWebSocket']),
    /**
     * 获取客服信息
     */
    getAccountQuery() {
      accountQuery().then(res => {
        console.log("获取客服信息", res);
        this.agent_info = {
          account_id: res.account_id,
          nick_name: res.nick_name
        }
      }).catch(err => {
        console.error("获取客服信息失败", err);
      });
    },
    /**
     * 返回显示的昵称
     * @param {string} senderId 发送方id
     */
    getSenderName(senderId) {
      console.log(senderId, "senderId", this.current_account.customer_id, "current_account.customer_id");
      if (senderId === (this.agent_info.account_id)) {
        return this.agent_info.nick_name || ("客服" + this.agent_info.account_id);
      } else {
        return this.current_account.nick_name || this.current_account.customer_id;
      }
      //return this.current_account.nick_name || this.current_account.customer_id;
    },
    /**
     * 获取用户消息列表
     */
    async getChatList() {
      const res = await getChatList();
      console.log("获取消息列表", res);
      //  const  = res || {};

      for (let i = 0; i < res.length; i++) {
        this.$set(this.onlineUsers, res[i].customer_id, { ...res[i], messages: [] });
      }
      console.log("在线用户列表", this.onlineUsers);
    },
    /**
     * 设置聊天对象
     */
    setChatAccount(user) {
      this.current_account = user;
      this.messages = user.messages;
      console.log("设置------------", this.analysis);
    },
    // 生成唯一ID
    /* generateUserId() {
      return 'user_' + Date.now() + '_' + Math.random().toString(36).substring(2, 8);
    }, */
    // 格式化时间
    formatTime() {
      const now = new Date();
      return `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
    },
    /**
     * 添加普通消息
     * @param {string} senderId 发送方id
     * @param {string} senderName 发送方名字
     * @param {string} content 消息内容
     */
    sendChatMessage(info) {
      console.log("添加消息", info);
      this.onlineUsers[info.rawReceiverId].messages.push({
        senderId: info.senderId, //发送方id
        senderName: info.senderName, //发送方名字
        rawReceiverId: info.rawReceiverId, //接收方id
        content: info.data, //内容
        fileType: info.fileType, //消息类型
        sendType: info.sendType, //发送给用户
        pic: "/static/img/bmale",
        time: this.formatTime()
      });
      this.scrollToBottom();
    },
    /**
     * 获取到消息
     * @param info
     */
    pullChatMessage(info) {
      console.log("添加消息", info);
      this.onlineUsers[info.senderId].messages.push({
        senderId: info.senderId, //发送方id
        senderName: info.senderName, //发送方名字
        rawReceiverId: info.rawReceiverId, //接收方id
        content: info.data, //内容
        fileType: info.fileType, //消息类型
        sendType: info.sendType, //发送给用户
        pic: "/static/img/bmale",
        time: this.formatTime()
      });
      this.scrollToBottom();
    },
    // 添加系统消息
    addSystemMessage(content) {
      /*  return;
     this.messages.push({
        type: 'system',
        content: content,
        time: this.formatTime()
      });
      this.scrollToBottom(); */
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    // 更新在线用户列表
    updateOnlineUsers(users) {
      this.onlineUsers = users;
    },
    /**
     * 移除离线用户
     * @param customer_id
     */
    // 移除离线用户
    removeOnlineUser(customer_id) {

    },
    // 发送消息 (使用 JSON 协议)
    /* sendChatMessage(content) {
      if (!this.socket || this.socket.readyState !== WebSocket.OPEN) return false;
      const messagePacket = {
        action: 'chat',
        payload: {
          senderId: this.current_account.customer_id,
          senderName: this.nick_name,
          content: content.trim(),
          timestamp: Date.now()
        }
      };
      this.socket.send(JSON.stringify(messagePacket));
      return true;
    }, */
    // 发送用户加入广播
    /* sendUserJoined() {
      if (!this.socket || this.socket.readyState !== WebSocket.OPEN) return;
      const joinPacket = {
        action: 'user_joined',
        payload: {
          customer_id: this.current_account.customer_id,
          nick_name: this.nick_name
        }
      };
      this.socket.send(JSON.stringify(joinPacket));
    }, */
    // 发送用户离开广播
    sendUserLeft() {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        const leftPacket = {
          action: 'user_left',
          payload: {
            customer_id: this.current_account.customer_id,
            nick_name: this.agent_info.nick_name
          }
        };
        this.socket.send(JSON.stringify(leftPacket));
      }
    },
    // 发送改名广播
    sendUserRenamed(oldName, newName) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        const renamePacket = {
          action: 'user_renamed',
          payload: {
            customer_id: this.current_account.customer_id,
            oldName: oldName,
            newName: newName
          }
        };
        this.socket.send(JSON.stringify(renamePacket));
      }
    },
    // 建立 WebSocket 连接
    /* connectWebSocket() {
      // 这里使用你的 WebSocket 连接逻辑
      // 如果需要使用你之前定义的 WebSocketClient 类，可以在这里集成
    }, */
    // 手动断开重连
    /* manualReconnect() {
      if (this.socket) {
        this.sendUserLeft();
        this.socket.close();
        this.socket = null;
      }
      this.reconnectAttempts = 0;
      if (this.reconnectTimer) clearTimeout(this.reconnectTimer);
      this.connectWebSocket();
    }, */
    // 发送消息逻辑 (UI调用)
    /**
     * 底部发送消息按钮
     * @param {string} content 发送的内容
     */
    sendMessage(content) {
      const str = this.analysis.encodeTextToUser(this.current_account.customer_id, content)
      this.sendWebSocketMessage(str);
      console.log("this.current_account.account_id", this.current_account.customer_id);
      const data = {
        rawReceiverId: this.current_account.customer_id, //接收方id
        sendType: "00", //发送给用户
        fileType: "01",
        senderId: this.agent_info.account_id,
        senderName: this.agent_info.nick_name,
        data: content,
        pic: "/static/img/bmale",
        time: this.formatTime()
      }
      this.sendChatMessage(data);
      this.newMessage = '';
    },
    // 修改昵称
    /* editUsername() {
      let newName = prompt("请输入新的昵称 (2~16个字符)", this.nick_name);
      if (newName && newName.trim().length > 0 && newName.trim().length <= 20) {
        const oldName = this.nick_name;
        const newUsername = newName.trim().substring(0, 20);
        this.nick_name = newUsername;

        // 发送改名广播
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
          this.sendUserRenamed(oldName, newUsername);
        } else {
          this.addSystemMessage(`📛 昵称已更改为: ${this.nick_name} (未连接，仅本地生效)`);
        }
      } else if (newName !== null) {
        alert("昵称长度需在1~20个字符");
      }
    }, */
    // 清理资源
    /**
     * 清理资源
     */
    cleanup() {
      if (this.websocket) {
        this.clearWebSocket();
      }
    },
    beforeUnloadHandler() {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.sendUserLeft();
      }
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.chat-container {
  width: 100%;
  height: 100%;
  min-height: 550px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(2px);
  box-shadow: 0 25px 45px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.15);
  overflow: hidden;
  display: flex;
  transition: all 0.2s ease;
}

/* 左侧用户列表样式 */
.people-list {
  width: 260px;
  background: #E0E0E0;
  backdrop-filter: blur(8px);
  border-right: 1px solid #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.people-header {
  padding: 18px 16px;
  height: 60px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  color: #000;
  font-size: 1rem;
}

.online-count {
  background: rgba(46, 204, 113, 0.3);
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 0.75rem;
  color: #2ecc71;
}

.people-content {
  flex: 1;
  overflow-y: auto;
  background-color: #fff;
}

.people-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  margin-bottom: 8px;
  /* border-radius: 12px; */
  transition: all 0.2s;
  cursor: pointer;
}

.people-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.people-item.current-user {
  background: #409eff;
  color: #fff !important;
  border: none;
  border-left: 5px solid #006fe2;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  background: linear-gradient(135deg, #667eea 0%, #8000ff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  font-size: 1rem;
  position: relative;
}

.user-avatar-haveMessage {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: red;
  position: absolute;
  right: -5px;
  top: -5px;
}

.people-item.current-user .user-avatar {
  background: linear-gradient(135deg, #c4dfff 0%, #e9f5ff 100%);
  color: #409eff;
}

.user-info {
  flex: 1;
}

.user-name-list {
  font-size: 0.9rem;
  font-weight: 500;
  color: #409eff;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.user-name-list-select {
  color: #fff;
  font-weight: 700;
  border: none;
}

.self-badge {
  font-size: 0.65rem;
  background: rgba(46, 204, 113, 0.3);
  padding: 2px 6px;
  border-radius: 10px;
  color: #2ecc71;
}

.user-status {
  font-size: 0.7rem;
  color: #2ecc71;
  padding: 4px;
  border-radius: 4px;
  background-color: #fff;
}

.empty-users {
  text-align: center;
  padding: 30px 20px;
  color: #8aa4b0;
  font-size: 0.8rem;
}

/* 右侧聊天区域 */
.chat-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chat-header {
  background: #E0E0E0;
  height: 60px;
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.title-section {
  display: flex;
  align-items: baseline;
  gap: 12px;
  flex-wrap: wrap;
}

.chat-title {
  font-size: 1.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #E0F2FE, #A5F3FC);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  letter-spacing: -0.3px;
}

.connection-badge {
  font-size: 0.7rem;
  background: #2ecc71;
  color: white;
  padding: 4px 10px;
  border-radius: 40px;
  font-weight: 600;
  transition: all 0.2s;
}

.connection-badge.disconnected {
  background: #e74c3c;
  box-shadow: 0 0 5px rgba(231, 76, 60, 0.5);
}

.user-info {
  padding: 6px 14px;
  /* border-radius: 60px; */
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  font-size: 0.85rem;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.user-name {
  color: #000 !important;
  font-weight: 600;
  max-width: 130px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-name-btn {
  background: none;
  border: none;
  color: #7f8c8d;
  cursor: pointer;
  font-size: 1rem;
  transition: 0.1s;
}

.edit-name-btn:hover {
  color: #333;
}

.message-area {
  flex: 1;
  overflow-y: auto;
  padding: 20px 18px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  background: rgba(255, 255, 255, 0.4);
  scroll-behavior: smooth;
}

.message-area::-webkit-scrollbar {
  width: 10px;
}

.message-area::-webkit-scrollbar-track {
  background: #1e2a32;
  border-radius: 10px;
}

.message-area::-webkit-scrollbar-thumb {
  background: #009afa;
  border-radius: 10px;
}

.people-content::-webkit-scrollbar {
  width: 10px;
}

.people-content::-webkit-scrollbar-track {
  background: #1e2a32;
}

.people-content::-webkit-scrollbar-thumb {
  background: #3e5a6b;
  border-radius: 10px;
}

.message {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  max-width: 85%;
  animation: fadeSlideUp 0.2s ease;
}

.message.own {
  align-self: flex-end;
  flex-direction: row-reverse;
}

.message-bubble {
  background: #2d3e4b;
  padding: 10px 16px;
  border-radius: 22px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  color: #edf2f7;
  word-break: break-word;
  font-size: 0.95rem;
  line-height: 1.4;
  transition: background 0.1s;
}

.message.own .message-bubble {
  background: #ffffff;
  background: linear-gradient(135deg, #6eb6ff, #409eff);
  color: white !important;
}

.message-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
  font-size: 0.7rem;
  gap: 4px;
}

.message-sender {
  font-weight: 700;
  color: #b9e2f0;
  font-size: 0.75rem;
  letter-spacing: 0.3px;
}

.message.own .message-sender {
  color: #eaa100;
  text-align: right;
}
.message.own .message-time{
  color: #2d3e4b;
}

.message-time {
  font-size: 0.6rem;
  color: #8aa4b0;
}

.message.own .message-time {
  text-align: right;
}

.message-line {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.system-message {
  text-align: center;
  font-size: 0.75rem;
  color: #003b66;
  background: rgba(0, 0, 0, 0.3);
  margin: 6px auto;
  padding: 6px 12px;
  border-radius: 40px;
  width: fit-content;
  max-width: 80%;
  backdrop-filter: blur(2px);
}

.input-area {
  background: rgba(25, 35, 45, 0.9);
  backdrop-filter: blur(10px);
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  gap: 12px;
  align-items: center;
}

.message-input {
  flex: 1;
  background: #1f2e38;
  border: 1px solid #3c5668;
  border-radius: 60px;
  padding: 12px 20px;
  font-size: 0.95rem;
  color: #f0f3f8;
  outline: none;
  transition: all 0.2s;
  font-family: inherit;
}

.message-input:focus {
  border-color: #2ecc71;
  box-shadow: 0 0 0 2px rgba(46, 204, 113, 0.3);
  background: #1b2a35;
}

.message-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.send-btn {
  background: #0f7b6e;
  border: none;
  color: white;
  font-weight: bold;
  padding: 10px 22px;
  border-radius: 40px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: 0.15s;
  font-family: inherit;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.send-btn:hover:not(:disabled) {
  background: #179e8c;
  transform: scale(1.02);
}

.send-btn:disabled {
  background: #4a6a78;
  cursor: not-allowed;
  opacity: 0.6;
}

.reconnect-btn {
  background: #2c3e50;
  border: 1px solid #5f7f92;
  padding: 6px 14px;
  border-radius: 30px;
  font-size: 0.75rem;
  cursor: pointer;
  color: #cfdee9;
  transition: 0.1s;
}

.reconnect-btn:hover {
  background: #1f3b48;
  color: white;
}

.status-bar {
  font-size: 0.7rem;
  padding: 4px 20px;
  background: #00000055;
  color: #bbd4e3;
  text-align: center;
}

@keyframes fadeSlideUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .people-list {
    width: 200px;
  }
}

@media (max-width: 550px) {
  .chat-container {
    height: 90vh;
    border-radius: 24px;
    flex-direction: column;
  }

  .people-list {
    width: 100%;
    max-height: 200px;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  }

  .message {
    max-width: 95%;
  }

  .send-btn {
    padding: 8px 16px;
  }
}
</style>